
export default class PluginProperties {

    constructor(designer, {
    } = {}) {
        this.designer = designer;
    }

    install() {

        this.unregisterPropertyChangedListener = this.designer.extent.registerPropertyChangedListener((name, valOld, valNew) => {
            this.raiseExtentChanged(this.designer.extent);
        })

        Object.defineProperty(this.designer, "_", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: {
                resolution: this.designer.resolution,
                extent: this.designer.extent,
                selectedItems: this.designer.selectedItems,
                action: this.designer.action,
            },
        });

        Object.defineProperty(this.designer, "resolution", {
            configurable: false,
            enumerable: true,
            get: () => {
                return this.designer._["resolution"];
            },
            set: (valNew) => {
                this.designer._["resolution"] = valNew;
                this.raiseResolutionChanged(valNew);
            },
        });

        Object.defineProperty(this.designer, "extent", {
            configurable: false,
            enumerable: true,
            get: () => {
                return this.designer._["extent"];
            },
            set: (valNew) => {
                const extent = this.designer._["extent"];
                extent.left = valNew.left;
                extent.top = valNew.top;
                extent.width = valNew.width;
                extent.height = valNew.height;
                this.raiseExtentChanged(valNew);
            },
        });

        Object.defineProperty(this.designer, "selectedItems", {
            configurable: false,
            enumerable: true,
            get: () => {
                return this.designer._["selectedItems"];
            },
            set: (valNew) => {

                this.designer._["selectedItems"].forEach(c => {
                    c.isEdit = false;
                    if (c._sys.parent)
                        c._sys.parent.showFocus = false;
                });

                if (valNew instanceof Array) {
                    this.designer._["selectedItems"] = valNew;
                }
                else if (valNew) {
                    if (this.designer._["selectedItems"].length === 1 && this.designer._["selectedItems"][0] === valNew)
                        return;

                    this.designer._["selectedItems"] = [valNew];
                }
                else {
                    this.designer._["selectedItems"] = [];
                }

                this.designer._["selectedItems"].forEach(c => {
                    if (c._sys.parent)
                        c._sys.parent.showFocus = true;
                });

                this.designer.properties.needSave = true;
                this.raiseSelectedItemsChanged(this.designer._["selectedItems"]);
                this.designer.eventEmitter.emit("selectedItemsChanged", this.designer._["selectedItems"]);
            },
        });

        Object.defineProperty(this.designer, "action", {
            configurable: false,
            enumerable: true,
            get: () => {
                return this.designer._["action"];
            },
            set: (valNew) => {

                let action = this.designer._["action"];
                if (action)
                    action.uninstall();

                this.designer._["action"] = action = valNew;
                if (action)
                    action.install();

                this.raiseActionChanged(valNew);
                this.designer.eventEmitter.emit("actionChanged", valNew);
            },
        });
    }

    uninstall() {
        this.unregisterPropertyChangedListener();
    }

    raiseResolutionChanged(val) {
        this.designer.resolutionListeners.forEach(c => c(val));
    }

    raiseExtentChanged(val) {
        this.designer.extentListeners.forEach(c => c(val));
    }

    raiseSelectedItemsChanged(val) {
        this.designer.selectedItemsListeners.forEach(c => c(val));
    }

    raiseActionChanged(val) {
        this.designer.actionChangedListeners.forEach(c => c(val));
    }
}